import React from 'react'
import { database, storage } from '../../Firebase/firebase';

function AdminDashBoard({profilePic,profilePicPath,id,first_name,last_name}) {
  const imageRef = React.useRef();
    const [uploadState, setUploadState] = React.useState(false);
    const handleUpdate = ()=>{
        if (imageRef.current?.files[0]?.name) {
          if (imageRef.current?.files[0]?.type.includes("image")) {

            setUploadState(true);
            if(profilePicPath){
                storage.ref(`profile/${profilePicPath}`).delete();
            }
            const uploadTask = storage
              .ref(`profile/${imageRef.current.files[0].name}`)
              .put(imageRef.current.files[0]);

            uploadTask.on(
              "state_changed",
              (snapshot) => {
                // setPostState(Math.floor((snapshot.bytesTransferred/snapshot.totalBytes)*100)+1)
              },
              (error) => {},
              () => {
                storage
                  .ref("profile")
                  .child(imageRef.current.files[0].name)
                  .getDownloadURL()
                  .then((url) => {
                    database.collection("profile").doc(id).update({
                      profilePic: url,
                      profilePicPath: imageRef.current.files[0].name,
                    });
                    setUploadState(false);
                  });
              }
            );
          }
        }
    }
    return (
      <div className="adminContainer flexBox">
        <div className="profilePicture flexBox">
          <h1>{`${first_name} ${last_name}`}</h1>
          <img
            src={profilePic || process.env.PUBLIC_URL + "/images/Logo.png"}
            alt="profilePic"
          />
          <input type="file" ref={imageRef} />
          <button disabled={uploadState} onClick={handleUpdate}>
            Update
          </button>
        </div>
      </div>
    );
}

export default AdminDashBoard
